const directories: Record<string, string> = { sales_rep: "sales-reps", distributor: "distributors", sub_distributor: "sub-distributors", counter: "counters", karigar: "karigars" };
export const profileDirectory = (role: string) => directories[role] ?? "sales-reps";
export function userProfilePath(orgSlug: string, role: string, id: string, viewerRole?: string) {
  const base = viewerRole === "counter" && role === "karigar" ? "counter" : "admin";
  return `/${orgSlug}/${base}/${profileDirectory(role)}/${id}`;
}
